import React, { forwardRef, useImperativeHandle, useState } from 'react';
import isUndefined from 'lodash/isUndefined';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import SidePanelModule from './SidePanelModule';
import { selectModuleIndex } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import { SIDE_PANEL_WIDTH } from 'src/presentation/components/pages/sidekick/threads/SidekickConstants';

export type SidePanelRef = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const SidePanel = forwardRef(
  ({ isReadOnly, isAnonymousModule }: { isReadOnly: boolean; isAnonymousModule: boolean }, ref) => {
    const moduleIndex = useSelector(selectModuleIndex);
    const [isOpen, setIsOpen] = useState(true);

    useImperativeHandle(ref, () => ({
      isOpen: isOpen,
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    }));

    return (
      <SidePanelWrapper isOpen={isOpen} ref={ref} data-aid="builder-side-panel">
        {isUndefined(moduleIndex) ? (
          <EmptySidePanel />
        ) : (
          <SidePanelModule readOnly={isReadOnly} isAnonymousModule={isAnonymousModule} />
        )}
      </SidePanelWrapper>
    );
  }
);

const EmptySidePanel = styled.div`
  :after {
    align-items: center;
    content: 'No Module Selected';
    display: flex;
    height: 100vh;
    justify-content: center;
    vertical-align: middle;
  }
`;

const SidePanelWrapper = styled.div`
  ${p => (p.isOpen ? `transform: translateX(0);` : `transform: translateX(${SIDE_PANEL_WIDTH});`)}
  background-color: ${p => p.theme.colors.white};
  bottom: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  margin: 0 auto;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: ${SIDE_PANEL_WIDTH};
  z-index: 2;
`;

export default SidePanel;
